interface Config {
  STAGE: string;
  API_ENDPOINT: string;
  REVISION: string;
  DOCS_BASE_PATH?: string;
  DOCS_ORIGIN?: string;
  DOCS_MEDIA_ORIGIN?: string;
}

let configCache: Config | null = null;

function getConfigPath(): string {
  const meta = document.querySelector<HTMLMetaElement>(
    'meta[name="config-path"]',
  );
  return meta?.content ?? "/config.json";
}

export async function loadConfig(): Promise<Config> {
  if (configCache) return configCache;
  const res = await fetch(getConfigPath());
  configCache = (await res.json()) as Config;
  return configCache;
}

export function getConfig(): Config {
  if (!configCache)
    throw new Error("Config not loaded. Call loadConfig() first.");
  return configCache;
}

export function getVariable<K extends keyof Config>(key: K): Config[K] {
  return getConfig()[key];
}
